import React from "react";

export default class ContactMap extends React.Component {
  render() {
    return (
      <>
        <section className="contact-page-google-map">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3963.6197277585993!2d3.3431929749933174!3d6.569585693423737!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x103b92071ad747bf%3A0x22e2a0c0503404a0!2sMagnet%20Shopping%20Plaza!5e0!3m2!1sen!2sng!4v1742277112375!5m2!1sen!2sng"
            style={{ border: "0px" }}
            allowfullscreen
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
            className="contact-page-google-map__one"
             title="Address"
          ></iframe>
        </section>
      </>
    );
  }
}
